import React from 'react'
import SidebarIcon1 from './Images/SidebarIcon1.svg'
import SidebarIcon11 from './Images/SidebarIcon11.svg'
import sidbaricon22 from './Images/sidbaricon22.svg'
import sidbaricon2 from './Images/sidbaricon2.svg'
import sidbaricon33 from './Images/sidbaricon33.svg'
import sidbaricon3 from './Images/sidbaricon3.svg'
import sidbaricon44 from './Images/sidbaricon44.svg'
import sidbaricon4 from './Images/sidbaricon4.svg'
import sidbaricon55 from './Images/sidbaricon55.svg'
import sidbaricon5 from './Images/sidbaricon5.svg'
import sidbaricon66 from './Images/sidbaricon66.svg'
import sidbaricon6 from './Images/sidbaricon6.svg'
import sidbaricon77 from './Images/sidbaricon77.svg'
import sidbaricon7 from './Images/sidbaricon7.svg'
import { CASHBRIDGE_LIKE, CHECK_COMPANY_TENANT } from '../../../../layouts/MainTenantconfig'

const SidbarContentOthers = [
    { text: "Overview", icon: SidebarIcon11, selectedIcon: SidebarIcon1, ShowType: "overview", subType: [] },
    {
        text: "KYC", icon: sidbaricon22, selectedIcon: sidbaricon2, ShowType: "kyc", subType: [
            { text: "Aadhar Varification", ShowType: "aadhaar" },
            { text: "Aadhar Validation", ShowType: "aadhaarValidation" },
            { text: "PAN", ShowType: "pan" },
            // { text: "Mobile OTP", ShowType: "mobileOtp" },
        ]
    },
    {
        text: "Credit Information", icon: sidbaricon33, selectedIcon: sidbaricon3, ShowType: "creditInfo", subType: [
            { text: "BAV", ShowType: "bav" },
            { text: "PDF Parsing by Netbanking", ShowType: "pdfParseNetbanking" },
            { text: "PDF Parsing by Doc Upload", ShowType: "pdfParseUpload" },
            // { text: "Account Aggregator", ShowType: "accountAggregator" },
        ]
    },
    {
        text: "Creditwriting", icon: sidbaricon44, selectedIcon: sidbaricon4, ShowType: "creditWritting", subType: [
            { text: "CRIF", ShowType: "crif" },
            // { text: "CIBIL", ShowType: "cibil" },
            // { text: "Fraud Check", ShowType: "fraudCheck" },
            // { text: "Risk Engine", ShowType: "riskEngine" },
        ]
    },
    {
        text: "Loan Process", icon: sidbaricon55, selectedIcon: sidbaricon5, ShowType: "loanProcess", subType: [
            { text: "eSign", ShowType: "esign" },
            { text: "e-mandate Registration", ShowType: "emandateRegistration" },
            // { text: "Hit Capture", ShowType: "hitCapture" },
        ]
    },
    // {
    //     text: "Payments", icon: sidbaricon66, selectedIcon: sidbaricon6, ShowType: "payment", subType: [
    //         { text: "Disbursement API", ShowType: "disbursmentApi" },
    //         { text: "Payment Gateway", ShowType: "paymentGateway" },
    //     ]
    // },
    // {
    //     text: "Platform APIs", icon: sidbaricon77, selectedIcon: sidbaricon7, ShowType: "platformApi", subType: [
    //         { text: "Call back", ShowType: "callback" },
    //         { text: "Logs", ShowType: "logs" },
    //     ]
    // },
]
const SidbarContentCashbridge = [
    { text: "Overview", icon: SidebarIcon11, selectedIcon: SidebarIcon1, ShowType: "overview", subType: [] },
    {
        text: "KYC", icon: sidbaricon22, selectedIcon: sidbaricon2, ShowType: "kyc", subType: [
            { text: "Aadhar Varification", ShowType: "aadhaar" },
            // { text: "Aadhar Validation", ShowType: "aadhaarValidation" },
            { text: "PAN", ShowType: "pan" },
            // { text: "Mobile OTP", ShowType: "mobileOtp" },
        ]
    },
    {
        text: "Credit Information", icon: sidbaricon33, selectedIcon: sidbaricon3, ShowType: "creditInfo", subType: [
            { text: "BAV", ShowType: "bav" },
            { text: "PDF Parsing by Netbanking", ShowType: "pdfParseNetbanking" },
            { text: "PDF Parsing by Doc Upload", ShowType: "pdfParseUpload" },
            // { text: "Account Aggregator", ShowType: "accountAggregator" },
        ]
    },
    {
        text: "Creditwriting", icon: sidbaricon44, selectedIcon: sidbaricon4, ShowType: "creditWritting", subType: [
            { text: "CRIF", ShowType: "crif" },
            // { text: "CIBIL", ShowType: "cibil" },
            // { text: "Fraud Check", ShowType: "fraudCheck" },
            // { text: "Risk Engine", ShowType: "riskEngine" },
        ]
    },
    {
        text: "Loan Process", icon: sidbaricon55, selectedIcon: sidbaricon5, ShowType: "loanProcess", subType: [
            { text: "eSign", ShowType: "esign" },
            { text: "e-mandate Registration", ShowType: "emandateRegistration" },
            // { text: "Hit Capture", ShowType: "hitCapture" },
        ]
    },
    // {
    //     text: "Payments", icon: sidbaricon66, selectedIcon: sidbaricon6, ShowType: "payment", subType: [
    //         { text: "Disbursement API", ShowType: "disbursmentApi" },
    //         { text: "Payment Gateway", ShowType: "paymentGateway" },
    //     ]
    // },
    // {
    //     text: "Platform APIs", icon: sidbaricon77, selectedIcon: sidbaricon7, ShowType: "platformApi", subType: [
    //         { text: "Call back", ShowType: "callback" },
    //         { text: "Logs", ShowType: "logs" },
    //     ]
    // },
]

export default function Sidebar({ handleTabType, isSidebarOpen, activeTab, activeSubTab }) {
    const SidbarContent = CHECK_COMPANY_TENANT(CASHBRIDGE_LIKE) ? SidbarContentCashbridge : SidbarContentOthers;
    return (
        <>
            <div className='Sidebar-content'>
                <ul className='sidebar-top-level-ul'>
                    {
                        SidbarContent?.length > 0 ? SidbarContent?.map((val, id) => {
                            return (
                                <li>
                                    <div className={`heading ${val?.ShowType == activeTab ? "active" : ""} ${isSidebarOpen ? "expanded" : ""}`} onClick={() => handleTabType(val, "activeTab")}>
                                        <img src={val?.ShowType == activeTab ? val?.selectedIcon : val?.icon} />
                                        <h5 className='sidebar-text'>
                                            {val?.text}
                                        </h5>
                                    </div>
                                    {
                                        val?.ShowType == activeTab && val?.subType?.length > 0 && isSidebarOpen ?
                                            <div className='sub-items'>
                                                <ul>
                                                    {
                                                        val?.subType?.map((subVal,ids)=>{
                                                            return(
                                                                <li key={ids}>
                                                                    <div className={`subHeading ${subVal?.ShowType == activeSubTab ? "active" : "" }`} onClick={() => handleTabType(subVal?.ShowType, "activeSubTab")}>
                                                                        <h6>{subVal?.text}</h6>
                                                                    </div>
                                                                </li>
                                                            )
                                                        })
                                                    }
                                                </ul>
                                            </div>
                                            : ""}
                                </li>
                            )
                        })
                            : ""}
                </ul>
            </div>
        </>
    )
}
